import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";

export const Wrapper = styled(Box)(() => ({
  height: "calc(100vh - 190px)",
}));